module.exports = __webpack_public_path__ + "img/openMenu.1806fbf4.png";